:host div#SSPBCatalogFilterPalette {
    width: 100%;
    margin-left: 18px;
    margin-bottom: 24px;
}

.ClearBoth {
    clear: both;
    height: 0px;
    line-height: 0px;
}

:host div#SSPBCatalogFilterPalette .SSPBFilterSelector {
    float: left;
    margin-right: 40px;
}

:host div#SSPBCatalogFilterPalette .SSPBFilterSelector:first-of-type {
    float: left;
    clear: left;
    margin-right: 40px;
}

:host div#SSPBCatalogFilterPalette .SSPBFilterSelector:last-of-type {
    float: left;
    clear: right;
}
